// extracted by mini-css-extract-plugin
module.exports = {"indicatorContainer":"Indicator_indicatorContainer__1yqI2","label":"Indicator_label__3goxE","indicator":"Indicator_indicator__2VQmc"};